/* @ngInject */
const railwayLabel = (
  valueHandler
) => {
  const self = {}

  self.class = 'Voie'
  self.title = 'Voies'

  self.fields = {
    id: {
      text: 'Id de la voie',
      messages: {
        invalid: 'L\'id de la voie est invalide',
      },
    },
    selectRailway: {
      text: 'Sélectionner la voie',
      choice: 'Choix de la voie',
    },
    selectId: {
      text: 'Sélectionner la voie',
      choice: 'Choix de la voie',
    },
    number: {
      text: 'Numéro',
      messages: {
        invalid: 'Le numéro de la voie est invalide',
        exists: 'Ce numéro de voie existe déjà',
      },
    },
    areaId: {
      text: 'Id de zone',
      messages: {
        invalid: 'L\'id de la zone est invalide',
      },
    },
    area: {
      text: 'Zone',
      choice: 'Choix de la zone',
    },
    length: {
      text: 'Longueur (m)',
    },
    availableLength: {
      text: 'Longueur dispo. (m)',
    },
    usedLength: {
      text: 'Longueur utilisée (m)',
    },
    ratioAvailableLength: {
      text: 'Disponible / total (m)',
    },
    ratioUsedLength: {
      text: 'Utilisée / total (m)',
    },
    wagonCount: {
      text: 'Wagons',
    },
    left: {
      text: 'Début',
    },
    right: {
      text: 'Fin',
      messages: {

      },
    },
    badge: {
      text: 'Badges',
    },
  }

  self.statements = {
    new: 'Nouvelle Voie',
    modifyPositions: 'Modifier les positions',
    validatePositions: 'Valider les modifications',
    reversePositions: 'Inverser les positions',
    newPosition: 'Nouvelle position',
    cancelModification: 'Annuler les modifications',
    list: 'Liste des voies',
    exists: 'Ce numéro de voie existe déjà',
    consult: 'Consult les voies',
    choosed: (_number) => {
      if (valueHandler.isEmpty(_number)) {
        _number = '-'
      }
      return 'Voie choisie : <strong>' + _number + '</strong>'
    },
    selectedRailway: (_railwayNumber) => {
      if (valueHandler.isEmpty(_railwayNumber)) {
        _railwayNumber = '-'
      }
      return 'Voie ' + _railwayNumber + ' sélectionnée'
    },
    availableLengthFunction: (_length) => {
      if (valueHandler.isEmpty(_length)) {
        _length = '-'
      }
      return 'Longueur disponible : ' + _length + ' mètre' + (_length > 1 ? 's' : '')
    },
    tooShortFor: (_wagonNumber) => {
      return 'La voie n\'est pas assez grande pour accueillir ce' + (_wagonNumber > 1 ? 's wagons' : ' wagon')
    },
    edit: (_number) => {
      return 'Modifier la voie ' + _number
    },
    editPosition: (_display) => {
      return _display ? 'Masquer les positions' : 'Afficher les positions'
    },
  }

  self.ask = {
    delete: 'Êtes-vous sûr de vouloir supprimer cette voie ?',
  }

  self.log = {
    save: {
      success: 'La voie a bien été créée.',
      failure: 'Une erreur est survenue lors de la création de la voie.',
      alreadyExists: 'Cette voie existe déjà',
    },
    update: {
      success: 'La voie a bien été modifiée.',
      failure: 'Une erreur est survenue lors de la modification de la voie.',
    },
    delete: {
      success: 'La voie a bien été supprimée.',
      failure: 'Une erreur a interrompu la suppression de la voie.',
      wagonOnRailway: 'Impossible de supprimer la voie, des wagons sont encore garés dessus.',
    },
    search: {
      success: (_length = 0) => {
        if (_length === 0) {
          return 'Aucune voie ne correspond à la recherche.'
        } else if (_length === 1) {
          return '1 voie a été trouvée.'
        } else if (_length > 1) {
          return _length + ' voies ont été trouvées.'
        }
        return 'Voie recherchée.'
      },
      failure: 'Impossible de rechercher les voies',
      noResult: 'Aucune voie ne correspond à cette recherche',
    },
  }

  self.badges = {
    full: '<span class="no-break">garage franc<span>',
  }

  return self
}

export default railwayLabel



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/railway/resources/labels.resource.js